export default __webpack_public_path__ + "static/media/title1.8ea57bf1.svg";